import { useCallback, useState } from 'react';
import { useDebounceValue } from 'usehooks-ts';

export function useSearchInputValueDebounce<T>(initialValue: T, delay: number) {
  const [inputValue, setDirectInputValue] = useState<T>(initialValue);
  const [debouncedInputValue, setDebouncedInputValue] = useDebounceValue<T>(initialValue, delay);

  const setInputValue = useCallback(
    (value: T) => {
      setDirectInputValue(value);
      setDebouncedInputValue(value);
    },
    [setDebouncedInputValue],
  );

  return { inputValue, debouncedInputValue, setInputValue };
}
